// reservebar.js
import {
	generateAddressModal,
	setReservebarLastProductMeta
} from './reservebar-address-modal';
import {generateCartModal} from './reservebar-cart-modal';
import {generateProductSummer} from './reservebar-product-summer';
import {initReservebarButtons, refreshReservebarButtons} from './reservebar-button-state';
import {initReservebarPrice} from './reservebar-product-price';
import {setStore} from './reservebar-store';
import {syncLiquidSdkAddressFromCookie} from './reservebar-config';

export function reserveBarHandler() {
	const mainContainer = document.querySelector('.main-container');
	const productSummer = document.querySelector('.rb-product-summer');

	if (mainContainer) {
		mainContainer.addEventListener('click', function (event) {
			// Quiz button
			if (event.target.classList.contains('quiz-add-to-cart')) {
				event.preventDefault();
				const popupTrigger = event.target.closest(
					'.reservebar-popup-trigger'
				);
				const liquidGroupingID = popupTrigger?.getAttribute(
					'reservebar-liquid-id'
				);

				if (popupTrigger) {
					setReservebarLastProductMeta({
						title:
							popupTrigger.getAttribute('data-product-title') ||
							'',
						attr:
							popupTrigger.getAttribute('data-product-attr') ||
							'',
						poster:
							popupTrigger.getAttribute('data-product-poster') ||
							''
					});
				}

				if (liquidGroupingID) {
					generateCartModal(liquidGroupingID);
				}

				return;
			}

			// Set address
			const addressTrigger = event.target.closest(
				'.reservebar-set-address-trigger'
			);
			if (addressTrigger) {
				event.preventDefault();
				const liquidGroupingID = addressTrigger.getAttribute(
					'reservebar-liquid-id'
				);

				setReservebarLastProductMeta({
					title:
						addressTrigger.getAttribute('data-product-title') || '',
					attr:
						addressTrigger.getAttribute('data-product-attr') || '',
					poster:
						addressTrigger.getAttribute('data-product-poster') || ''
				});

				if (liquidGroupingID) {
					generateAddressModal(liquidGroupingID, {
						title:
							addressTrigger.getAttribute('data-product-title') ||
							'',
						attr:
							addressTrigger.getAttribute('data-product-attr') ||
							'',
						poster:
							addressTrigger.getAttribute('data-product-poster') ||
							''
					});
				}
				return;
			}

			// Cart trigger
			const cartTrigger = event.target.closest(
				'.reservebar-cart-trigger'
			);
			if (cartTrigger) {
				event.preventDefault();
				const liquidGroupingID = cartTrigger.getAttribute(
					'reservebar-liquid-id'
				);

				setReservebarLastProductMeta({
					title: cartTrigger.getAttribute('data-product-title') || '',
					attr: cartTrigger.getAttribute('data-product-attr') || '',
					poster:
						cartTrigger.getAttribute('data-product-poster') || ''
				});

				if (liquidGroupingID) {
					generateCartModal(liquidGroupingID);
				}
			}
		});
	}

	window.addEventListener('reservebar:buttons-added', () => {
		setStore();
		refreshReservebarButtons();
	});

	if (productSummer) {
		const liquidGroupingID =
			productSummer.getAttribute('data-liquid-id') || '';
		setReservebarLastProductMeta({
			title: productSummer.getAttribute('data-product-title') || ''
		});

		generateProductSummer(liquidGroupingID, productSummer, {});
	}
	import(
		'Assets/scss/modules/library-modules/reservebar-popup/reservebar-popup.scss'
	);
}
export default function reserveBar() {
	setStore();
	// Defer until after liquidSDK.init (registered later in base.twig).
	setTimeout(() => syncLiquidSdkAddressFromCookie(), 0);
	reserveBarHandler();
	initReservebarButtons();
	initReservebarPrice();
}
